import React, {useEffect, useState} from "react";
import './_gender-select-dropdown.scss';
import GenderSelectOption from "./gender-select-option/gender-select-option";
import {RootState} from '../../../../../store/configureStore';
import {useSelector} from 'react-redux';
import {Config} from "../../../../../constants/Config";

const baseClass = 'genderSelectDropdown'

interface GenderSelectDropdownPropTypes {
  genderOptions: any,
  saveGenderOption?: any
}

const GenderSelectDropdown = (props: GenderSelectDropdownPropTypes): JSX.Element => {
  const genderOptions: any = props.genderOptions ? [ Config.defaultGenderOption, ...props.genderOptions] : [Config.defaultGenderOption]
  const [selectedGenders, setSelectedGender] = useState({})
  const savedGenderFilter: any = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedGenderFilter)

  useEffect(() => {
    let selectedGenderObject = {}
    for (let i = 0; i < genderOptions.length; i++) {
      if (genderOptions[i].name === savedGenderFilter.name) {
        selectedGenderObject = {
          ...selectedGenderObject,
          [genderOptions[i].name]: true
        }
      } else {
        selectedGenderObject = {
          ...selectedGenderObject,
          [genderOptions[i].name]: false
        }
      }
    }
    setSelectedGender(selectedGenderObject)
  }, [genderOptions.length, savedGenderFilter])

  const handleOptionSelections = (genderOption: any) => {
    let updatedSelectedGenders = {}
    for (let i = 0; i < genderOptions.length; i++) {
      if (genderOptions[i].name === genderOption.name) {
        updatedSelectedGenders = {
          ...updatedSelectedGenders,
          [genderOptions[i].name]: true
        }
      } else {
        updatedSelectedGenders = {
          ...updatedSelectedGenders,
          [genderOptions[i].name]: false
        }
      }
    }
    setSelectedGender(updatedSelectedGenders)
    if (props.saveGenderOption) {
      props.saveGenderOption(genderOption)
    }
  }

  const genderOptionsList = genderOptions.map((genderOption: any, index: number) =>
    <GenderSelectOption genderOption={genderOption} key={`gender-option-${index}`}
      // @ts-ignore
                        isOptionSelected={selectedGenders ? selectedGenders[genderOption.name] : null}
                        handleOptionSelections={handleOptionSelections}/>
  );

  return (
    <div className={`${baseClass}`}>
      {genderOptionsList}
    </div>
  )
}

export default GenderSelectDropdown;
